var y = (C, u, l) => new Promise((f, r) => {
  var a = (o) => {
    try {
      s(l.next(o));
    } catch (n) {
      r(n);
    }
  }, d = (o) => {
    try {
      s(l.throw(o));
    } catch (n) {
      r(n);
    }
  }, s = (o) => o.done ? f(o.value) : Promise.resolve(o.value).then(a, d);
  s((l = l.apply(C, u)).next());
});
import { a as w, m as k, u as A, o as R, b as E, c as t, e as c, f as i, F as _, h as V, l as p, w as b, i as g } from "./define-element-XpjsV6s1.js";
import { u as S } from "./use-cart-D8NOb7eE.js";
import { i as P } from "./utils-CMsllPx8.js";
import { I as x } from "./Input-yplyeePD.js";
import { B } from "./Button-D5lKR5Sd.js";
import { L as I } from "./Loader-CeIJU_1y.js";
import { _ as F } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const L = {
  ref: "container",
  class: "offset-promo-code",
  "aria-live": "polite"
}, N = {
  __name: "PromoCode",
  setup(C) {
    const { cart: u, applyPromoCode: l, removePromoCode: f, isApplyingPromoCode: r } = S(), a = w(""), d = k(() => {
      var v, e;
      return (e = (v = u.value.config) == null ? void 0 : v.promo_code) != null ? e : "";
    }), s = k(() => !P(a.value));
    function o() {
      return y(this, null, function* () {
        yield f(), a.value = "";
      });
    }
    const n = A("container");
    return R(() => {
      E(n.value);
    }), (v, e) => (t(), c("div", L, [
      i(P)(d.value) ? (t(), c(_, { key: 1 }, [
        V(x, {
          modelValue: a.value,
          "onUpdate:modelValue": e[2] || (e[2] = (m) => a.value = m),
          label: "Have a promo code or gift card?",
          placeholder: "Enter code here...",
          floating: !0
        }, null, 8, ["modelValue"]),
        i(r) ? (t(), p(I, { key: 0 })) : (t(), p(B, {
          key: 1,
          variant: "alt",
          onClick: e[3] || (e[3] = (m) => i(l)(a.value)),
          disabled: !s.value
        }, {
          default: b(() => e[5] || (e[5] = [
            g(" Apply ", -1)
          ])),
          _: 1,
          __: [5]
        }, 8, ["disabled"]))
      ], 64)) : (t(), c(_, { key: 0 }, [
        V(x, {
          modelValue: d.value,
          "onUpdate:modelValue": e[0] || (e[0] = (m) => d.value = m),
          label: "Applied code",
          disabled: "true",
          floating: !0
        }, null, 8, ["modelValue"]),
        i(r) ? (t(), p(I, { key: 0 })) : (t(), p(B, {
          key: 1,
          variant: "alt",
          onClick: e[1] || (e[1] = (m) => o())
        }, {
          default: b(() => e[4] || (e[4] = [
            g("Remove", -1)
          ])),
          _: 1,
          __: [4]
        }))
      ], 64))
    ], 512));
  }
}, D = /* @__PURE__ */ F(N, [["__scopeId", "data-v-110d83be"]]);
export {
  D as P
};
